import React from 'react';
import {
  Alert,
  Chip,
  Paper,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material';
import {
  getSupportAccessCatalog,
  type SupportCatalog,
} from '../services/apiService.ts';

const PermissionProfilesPage: React.FC = () => {
  const [loading, setLoading] = React.useState(true);
  const [error, setError] = React.useState<string | null>(null);
  const [catalog, setCatalog] = React.useState<SupportCatalog | null>(null);

  React.useEffect(() => {
    (async () => {
      setLoading(true);
      setError(null);
      try {
        setCatalog(await getSupportAccessCatalog());
      } catch (err: any) {
        setError(err?.response?.data?.message || err?.message || 'Nu am putut incarca profilele de permisiuni.');
      } finally {
        setLoading(false);
      }
    })();
  }, []);

  return (
    <Stack spacing={3}>
      <Stack spacing={1}>
        <Typography variant="overline" color="text.secondary">
          Internal Access
        </Typography>
        <Typography variant="h4">Permission Profiles</Typography>
        <Typography color="text.secondary">
          Catalogul intern de meniuri si profile care alimenteaza assignment-urile pe locatie.
        </Typography>
      </Stack>

      {error ? <Alert severity="error">{error}</Alert> : null}

      <Paper sx={{ p: 3 }}>
        <Stack direction={{ xs: 'column', md: 'row' }} spacing={3}>
          <Stack spacing={1}>
            <Typography variant="subtitle1">Support menus</Typography>
            <Typography variant="h5">{catalog?.menus.length ?? 0}</Typography>
          </Stack>
          <Stack spacing={1}>
            <Typography variant="subtitle1">Profiles</Typography>
            <Typography variant="h5">{catalog?.profiles.length ?? 0}</Typography>
          </Stack>
        </Stack>
      </Paper>

      <Paper sx={{ overflowX: 'auto' }}>
        <Table size="small">
          <TableHead>
            <TableRow>
              <TableCell>Profile</TableCell>
              <TableCell>Scope</TableCell>
              <TableCell>Description</TableCell>
              <TableCell>Grants</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {(catalog?.profiles || []).map((profile) => (
              <TableRow key={profile.code}>
                <TableCell>
                  <Stack spacing={0.5}>
                    <Typography fontWeight={700}>{profile.name}</Typography>
                    <Typography variant="body2" color="text.secondary">
                      {profile.code}
                    </Typography>
                  </Stack>
                </TableCell>
                <TableCell>{profile.appScope}</TableCell>
                <TableCell>{profile.description || '-'}</TableCell>
                <TableCell>
                  <Stack direction="row" spacing={1} flexWrap="wrap">
                    {profile.grants.map((grant) => (
                      <Chip key={`${profile.code}-${grant}`} label={grant} size="small" variant="outlined" />
                    ))}
                  </Stack>
                </TableCell>
              </TableRow>
            ))}
            {!catalog?.profiles.length && !loading ? (
              <TableRow>
                <TableCell colSpan={4}>
                  <Typography color="text.secondary">
                    Nu exista profile disponibile in catalog.
                  </Typography>
                </TableCell>
              </TableRow>
            ) : null}
          </TableBody>
        </Table>
      </Paper>
    </Stack>
  );
};

export default PermissionProfilesPage;
